import { render, staticRenderFns } from "./ScatterGraph.vue?vue&type=template&id=a4a9b510&scoped=true"
import script from "./ScatterGraph.vue?vue&type=script&lang=ts"
export * from "./ScatterGraph.vue?vue&type=script&lang=ts"
import style0 from "./ScatterGraph.vue?vue&type=style&index=0&id=a4a9b510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a9b510",
  null
  
)

export default component.exports